import moment from 'moment'
import 'moment/locale/tr'
import { localize } from 'vee-validate'
import i18n, { DEFAULT_LOCALE, SUPPORTED_LOCALES, NUMBER_LOCALES } from '@/libs/i18n'

/*
 * Dil değişiminin tek giriş noktası. Tercih localStorage'da tutulur;
 * jwtService aynı değeri her isteğe `Locale` başlığı olarak ekler.
 */
export function setLocale(locale) {
  const value = SUPPORTED_LOCALES.includes(locale) ? locale : DEFAULT_LOCALE
  i18n.locale = value
  localStorage.setItem('locale', value)
  moment.locale(value)
  localize(value)
  document.documentElement.setAttribute('lang', value)
}

function formatMoment(value, formatKey) {
  if (!value) {
    return '-'
  }
  const date = moment(value)
  return date.isValid() ? date.format(i18n.t(formatKey)) : '-'
}

export function formatDate(value) {
  return formatMoment(value, 'formats.date')
}

export function formatDateTime(value) {
  return formatMoment(value, 'formats.dateTime')
}

export function formatNumber(value, minimumFractionDigits = 0) {
  const number = Number(value)
  if (Number.isNaN(number)) {
    return value
  }
  const formatter = new Intl.NumberFormat(NUMBER_LOCALES[i18n.locale] || NUMBER_LOCALES[DEFAULT_LOCALE], {
    minimumFractionDigits,
  })
  return formatter.format(number)
}
